import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=b80187b8&scoped=true&"
import script from "./BaseSelect.vue?vue&type=script&lang=js&"
export * from "./BaseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80187b8",
  null
  
)

export default component.exports